import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { TabLink, TabLinks } from '@change-corgi/design-system-legacy/components/navigation';

import { EditForm } from './components/EditForm';
import { Settings } from './components/Settings';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { selectedTab },
	} = usePageBody();

	return (
		<div className="px-4 pt-8 pb-10 md:px-12 md:pt-12">
			<TabLinks
				selected={selectedTab}
				data-qa="page-body-tab-links"
				sx={{
					nav: {
						'& > div:first-of-type': {
							borderBottom: '2px solid var(--color-stroke-weaker)',
						},
						'ul > li > a > span': {
							fontFamily: 'unset',
						},
						...(selectedTab === 'edit' && {
							'ul > li:first-of-type': {
								color: 'var(--color-typography-interactive)',
								fontWeight: 700,
								borderBottom: '2px solid var(--color-stroke-selected)',
							},
							'ul > li:last-of-type': {
								color: 'var(--color-typography-weaker)',
							},
						}),
						...(selectedTab === 'settings' && {
							'ul > li:first-of-type': {
								color: 'var(--color-typography-weaker)',
							},
							'ul > li:last-of-type': {
								color: 'var(--color-typography-interactive)',
								fontWeight: 700,
								borderBottom: '2px solid var(--color-stroke-selected)',
							},
						}),
					},
				}}
			>
				<TabLink data-qa="edit-tab" name="edit" to="#">
					<Translate value="corgi.petition.edit.tabs.edit_v2" />
				</TabLink>
				<TabLink data-qa="settings-tab" name="settings" to="?tab=settings">
					<Translate value="corgi.petition.edit.tabs.settings" />
				</TabLink>
			</TabLinks>
			{selectedTab === 'edit' && (
				<div className="sm:pt-8 md:pt-10">
					<EditForm />
				</div>
			)}
			{selectedTab === 'settings' && (
				<div className="sm:pt-8 md:pt-8">
					<Settings />
				</div>
			)}
		</div>
	);
};
